//@ts-check
import {Modal, Toggle} from '@/components/atoms'
import {SegmentModal} from '@/containers/Promotions/components/SegmentModal/SegmentModal'
import {SegmentGroup} from '@/containers/Promotions/components/SegmentSection/SegmentGroup'
import {useProductComboSegments} from '@/hooks/productCombo/useProductComboSegments'
import {Font} from 'pepsico-ds'
import {useState} from 'react'

const defaultSegmentModalState = {
  show: false,
  type: '',
  isInclude: false,
}

export const ComboSegmentSection = () => {
  const {
    segmentConfiguration,
    isAllCustomers,
    isExcludeEnabled,
    handleRemoveRequest,
    toggleResetKey,
    showConfirmationModal,
    handleSegmentSubmissionRequest,
    handleAllCustomersToggleRequest,
    handleExcludeToggleRequest,
    handleConfirmPendingChange,
    handleCancelPendingChange,
  } = useProductComboSegments()
  const [segmentModalState, setSegmentModalState] = useState(defaultSegmentModalState)

  const handleSegmentSelection = (items, isInclude) => {
    const type = items?.[0]?.id
    if (!type) {
      return
    }
    setSegmentModalState({
      show: true,
      type,
      isInclude,
    })
  }

  const handleCloseSegmentModal = () => {
    setSegmentModalState(defaultSegmentModalState)
  }

  const handleSegmentSubmission = (selectedSegments, _groupIndex, type) => {
    handleSegmentSubmissionRequest(selectedSegments, type)
    handleCloseSegmentModal()
  }

  const includedSegmentGroup = segmentConfiguration?.includedSegments?.[0] ?? null

  const existingSelection = isExcludeEnabled
    ? segmentConfiguration?.excludedSegment?.segments
    : includedSegmentGroup?.segments

  return (
    <>
      <Font variant="bold">Segments</Font>
      <Toggle
        key={`all-customers-${toggleResetKey}`}
        updateValue={handleAllCustomersToggleRequest}
        value={isAllCustomers}
        uiSchema={{size: 'small', label: 'All Customers'}}
      />
      {!isAllCustomers && (
        <SegmentGroup
          key={`included-segments-${toggleResetKey}`}
          groupIndex={null}
          segmentGroup={includedSegmentGroup}
          onSegmentSelection={items => handleSegmentSelection(items, true)}
          handleRemove={handleRemoveRequest}
          tagsSeparator="OR"
          dropdownLabel={'Segments *'}
        />
      )}
      <div className="h-px bg-gray-600" />
      <Toggle
        key={`exclude-${toggleResetKey}`}
        disabled={!isAllCustomers}
        updateValue={handleExcludeToggleRequest}
        value={isExcludeEnabled}
        uiSchema={{size: 'small', label: 'Exclude'}}
      />
      {isExcludeEnabled && (
        <SegmentGroup
          key={`excluded-segments-${toggleResetKey}`}
          groupIndex={null}
          segmentGroup={segmentConfiguration?.excludedSegment}
          onSegmentSelection={items => handleSegmentSelection(items, false)}
          handleRemove={handleRemoveRequest}
          tagsSeparator="OR"
        />
      )}
      <SegmentModal
        key={`segment-modal-${segmentModalState.show}-${segmentModalState.type}`}
        show={segmentModalState.show}
        type={segmentModalState.type}
        groupIndex={segmentModalState.groupIndex}
        existingSelections={existingSelection ?? []}
        onSubmit={handleSegmentSubmission}
        onClose={handleCloseSegmentModal}
      />
      <Modal
        showModal={showConfirmationModal}
        title={'Changing the Customer Segment will reset the Product List'}
        text={
          'If you change the customer segment, the current product list in this combo will be cleared. Do you want to continue?'
        }
        primaryButtonText="Yes"
        secondaryButtonText="No"
        showSecondaryButton={true}
        classNameWrapper="min-h-80"
        onCloseModal={handleCancelPendingChange}
        onClickSecondaryButton={handleCancelPendingChange}
        onClickPrimaryButton={handleConfirmPendingChange}
        hideCloseButton={true}
      />
    </>
  )
}
